import axios from 'axios';
import VueCookies from "vue-cookies";

//登陆
export const GetUserSysInfot = params => {
    return axios.post('/login', params).then(res => res.data);
};
//获取用户名称
export const getUserInfo = params => {
    return axios.post('/userInfo/userInfo', params).then(res => res.data);
};
export const checkCustomer = params => {
    return axios.post('/crm/customer/check', params).then(res => res.data);
};

//附件查询接口
export const attachmentList = params => {
    return axios.post('/attachment/list', params).then(res => res.data);
};

//crm
//已询价记录
export const inquiryLastDetail = params => {
    return axios.post('/inquiry/last/detail', params).then(res => res.data);
};
//用户列表
export const GetCustomerlist = params => {
    return axios.post('/crm/customer/list', params).then(res => res.data);
};
//新增客户
export const GetCustomerAdd = params => {
    return axios.post('/crm/customer/add', params).then(res => res.data);
};
//查看详情
export const crmCustomerdetail = params => {
    return axios.post('/crm/customer/detail', params).then(res => res.data);
};
//修改详情
export const crmCustomerUpdatedetail = params => {
    return axios.post('/crm/customer/update/detail', params).then(res => res.data);
};
//修改保存
export const crmCustomerUpdate = params => {
    return axios.post('/crm/customer/update', params).then(res => res.data);
};
//跟进保存
export const crmCustomerfollowadd = params => {
    return axios.post('/crm/customer/follow/add', params).then(res => res.data);
};
//收藏接口
export const crmCustomerUpdateEnshrine = params => {
    return axios.post('/crm/customer/update/enshrine', params).then(res => res.data);
};
//获取业务员下面所有用户列表
export const crmCustomerAllList = params => {
    return axios.post('/crm/customer/all/sell/list', params).then(res => res.data);
};
//获取业务员下面所有已合作的用户列表
export const crmCustomerSellList = params => {
    return axios.post('/crm/customer/all/sell/sub/list', params).then(res => res.data);
};
//获取关联用户
export const crmCustomerRelationList = params => {
    return axios.post('/crm/customer/relation/list', params).then(res => res.data);
};
//核保信息数据
export const crmCustomerGetpolicy = params => {
    return axios.post('/policy/main/queryUnderwriteStatistics', params).then(res => res.data);
};
//理赔信息数据
export const crmCustomerGetclaim = params => {
    return axios.post('/policy/claim/queryClaimStatistics', params).then(res => res.data);
};
//理赔未支付解禁
export const claimUnpaidRelease = params => {
    return axios.post('/policy/claim/claimUnpaidRelease', params).then(res => res.data);
};
//理赔未支付财务首页统计
export const queryClaimUnpaidCount = params => {
    return axios.post('/pay/policy/queryClaimUnpaidCount', params).then(res => res.data);
};

export const queryClaimReturnVisitCount = params => {
    return axios.post('/policy/claim/queryClaimUnpaidCount', params).then(res => res.data);
};
//获取未合作保险标的
export const crmCustomersubject = params => {
    return axios.post('/crm/customer/insurance/subject', params).then(res => res.data);
};


// 客户管理页面
// 客户管理列表
export const manageCustomerList = params => {
    return axios.post('/manage/customer/list', params).then(res => res.data);
};
//客户管理客户详情
export const manageCustomerDetail = params => {
    return axios.post('/manage/customer/detail', params).then(res => res.data);
};
//客户管理修改详情
export const manageCustomerUpdateDetail = params => {
    return axios.post('/manage/customer/update/detail', params).then(res => res.data);
};
//客户管理修改保存
export const manageCustomerUpdatSave = params => {
    return axios.post('/manage/customer/update', params).then(res => res.data);
};

//出单页面
export const inquiryUpdateType = params => {
    return axios.post('/inquiry/update/type', params).then(res => res.data);
};
//投保状态保存
export const inquiryUpdateState = params => {
    return axios.post('/inquiry/update/state', params).then(res => res.data);
};
//出单拒绝
export const inquiryUpdateRenew = params => {
    return axios.post('/inquiry/update/type/renew', params).then(res => res.data);
};
//批量出单拒绝
export const inquiryUpdateRenewBatch = params => {
    return axios.post('/inquiry/batch/update/type/renew', params).then(res => res.data);
};
////财务管理 保險公司管理模块
export const GetcompanyList = params => {
    return axios.post('/company/list', params).then(res => res.data);
};
//新增公司
export const GetcompanySave = params => {
    return axios.post('/company/save', params).then(res => res.data);
};
//公司详情
export const Getcompanydetail = params => {
    return axios.post('/company/detail', params).then(res => res.data);
};
//保险公司修改保存
export const GetcompanyUpdate = params => {
    return axios.post('/company/update', params).then(res => res.data);
};
//保险公司删除
export const GetcompanyDel = params => {
    return axios.post('/company/delete', params).then(res => res.data);
};


//财务管理 支付管理 列表查询
export const GetFinanceList = params => {
    return axios.post('/finance/list', params).then(res => res.data);
};
//财务管理 支付管理 列表查询 国外
export const GetFinanceListForeign = params => {
    return axios.post('/foreign/finance/list', params).then(res => res.data);
};
//财务管理 支付管理 记录更新
export const updateFinance = params => {
    return axios.post('/finance/update', params).then(res => res.data);
};
//财务管理 支付管理 批量更新
export const batchUpdateFinance = params => {
    return axios.post('/finance/batch/update', params).then(res => res.data);
};
//财务管理 支付管理 详情
export const GetFinanceDetail = params => {
    return axios.post('/finance/detail', params).then(res => res.data);
};
//财务管理 开票列表
export const GetinvoiceList = params => {
    return axios.post('/invoice/list', params).then(res => res.data);
};
//经纪费结算管理 开票列表
export const GetinvoiceListForeign = params => {
    return axios.post('/foreign/invoice/list', params).then(res => res.data);
};
//开票详情
export const GetinvoiceDetail = params => {
    return axios.post('/invoice/detail', params).then(res => res.data);
};
//开票详情-国外
export const GetinvoiceDetailForeign = params => {
    return axios.post('/foreign/invoice/detail', params).then(res => res.data);
};
//开票批量修改
export const Getinvoiceoperate = params => {
    return axios.post('/invoice/operate', params).then(res => res.data);
};
//催收列表
export const payPolicyList = params => {
    return axios.post('/pay/policy/list', params).then(res => res.data);
};
//出险保单未支付催收列表
export const findClaimUnpaidList = params => {
    return axios.post('/pay/policy/findClaimUnpaidList', params).then(res => res.data);
};
//正常保费催收-国外
export const payPolicyListForeign= params => {
    return axios.post('/foreign/pay/policy/list', params).then(res => res.data);
};
//催收详情
export const payPolicyDetail = params => {
    return axios.post('/pay/policy/detail', params).then(res => res.data);
};
//出险保单未支付催收详情
export const claimUnpaidDetail = params => {
    return axios.post('/pay/policy/claimUnpaidDetail', params).then(res => res.data);
};

//修改状态
export const payPolicyupdate = params => {
    return axios.post('/pay/policy/update', params).then(res => res.data);
};
//修改字段
export const payPolicyupdateFiled = params => {
    return axios.post('/pay/policy/update/all', params).then(res => res.data);
};
//批量修改客户通知状态
export const notifyClientBatchUpdate = params => {
    return axios.post('/pay/policy/update/informCustomer', params).then(res => res.data);
};
//开票导出
export const invoiceExcel = params => {
    return axios.post('/invoice/create/excel', params, {responseType: 'blob'}).then(res => res.data);
};
//正常保费催收-导出
export const policyExcel = params => {
    return axios.post('/pay/policy/create/excel', params, {responseType: 'blob'}).then(res => res.data);
};
//正常保费催收-导出-国外
export const policyExcelForeign = params => {
    return axios.post('/foreign/pay/policy/create/excel', params, {responseType: 'blob'}).then(res => res.data);
};

//客户统计保费统计
export const queryUnderwriteStatistics = params => {
    return axios.post('/policy/main/queryUnderwriteStatistics', params).then(res => res.data);
};
//客户理赔信息统计
export const queryClaimStatistics = params => {
    return axios.post('/policy/claim/queryClaimStatistics', params).then(res => res.data);
};

///////////////////////////////////////////////////////////////////////////
// 保单页面接口
// 保单查询
export const queryListByPage = params => {
    return axios.post('/policy/main/queryListByPage', params).then(res => res.data);
};
//新增保单接口
export const policymainSave = params => {
    return axios.post('/policy/main/save', params).then(res => res.data);
};
//保单详情接口
export const policyqueryDetail = params => {
    return axios.post('/policy/main/queryDetail', params).then(res => res.data);
};
//保单修改接口
export const policyqueryUpdate = params => {
    return axios.post('/policy/main/update', params).then(res => res.data);
};
//保单删除接口
export const policyquerydelete = params => {
    return axios.post('/policy/main/delete', params).then(res => res.data);
};
export const policyQueryListByPage = params => {
    return axios.post('/pay/policy/queryListByPage', params).then(res => res.data);
};
//校验保单号是否存在
export const checkPolicyNoExists = params => {
    return axios.post('/policy/main/checkPolicyNoExists', params).then(res => res.data);
};

//审核保单详情
export const paypolicyqueryDetail = params => {
    return axios.post('/pay/policy/queryDetail', params).then(res => res.data);
};
//批单接口
export const policymainCorrect = params => {
    return axios.post('/policy/main/correct', params).then(res => res.data);
};
//批单编辑接口
export const policymainCorrectEdit = params => {
    return axios.post('/policy/main/correctUpdate', params).then(res => res.data);
};
//续保管理//
// 续保清单列表接口
export const policyReneListByPage = params => {
    return axios.post('/policy/renew/queryListByPage', params).then(res => res.data);
};
//续保分配
export const policyRenewdistribute = params => {
    return axios.post('/policy/renew/distribute', params).then(res => res.data);
};
//续保分配
export const policyRenewLostback = params => {
    return axios.post('/policy/renew/lostBack', params).then(res => res.data);
};
//续保批量派工
export const distributionBatchRequest = params => {
    return axios.post('/policy/renew/distributeBatch', params).then(res => res.data);
};
//获取角色信息列表
export const queryUserListOfRole = params => {
    return axios.get('/staff/sysStaff/queryUserListOfRole?roleCode=' + params).then(res => res.data);
};
//获取所有公司列表
export const getAllcompany = params => {
    return axios.post('/company/list/all', params).then(res => res.data);
};
//获取不同角色的备注和保险标的，联系人
export const manageCustomerRemark = params => {
    return axios.post('/manage/customer/remark', params).then(res => res.data);
};
//审核接口
export const payPolicyAduit = params => {
    return axios.post('/pay/policy/aduit', params).then(res => res.data);
};

//获取菜单列表
export const getMenuList = params => {
    return axios.post('/menuManagers/sysMenu/getMenuList', params).then(res => res.data);
};

//下载接口
export const fileDownload = params => {
    return axios.get('/file/download?attachmentId=' + params, {responseType: 'blob'}).then(res => res.data);
};
/////////////////////////////询价页面功能//////////////////////
//新增询价
export const inquirySave = params => {
    return axios.post('/inquiry/save', params).then(res => res.data);
};
//询价列表-承保人
export const inquiryWorkerList = params => {
    return axios.post('/inquiry/worker/list', params).then(res => res.data);
};
//询价列表-核保经理
export const inquiryList = params => {
    return axios.post('/inquiry/list', params).then(res => res.data);
};
//询价详情
export const inquiryDetail = params => {
    return axios.post('/inquiry/detail', params).then(res => res.data);
};
//询价修改
export const inquiryUpdate = params => {
    return axios.post('/inquiry/update', params).then(res => res.data);
};
//丢失、生成保单
export const inquiryUpdateStatus = params => {
    return axios.post('/inquiry/update/status', params).then(res => res.data);
};
//询价丢失转询价
export const turnToEnquiry = params => {
    return axios.post('/inquiry/update/status', params).then(res => res.data);
};
//派工
export const inquiryWorker = params => {
    return axios.post('/inquiry/worker', params).then(res => res.data);
};
//询价新增跟进
export const inquiryfollowAdd = params => {
    return axios.post('/inquiry/follow/add', params).then(res => res.data);
};

////////////////////////////////////////////////////////////////////////////
//用户新增
export const userAdd = params => {
    return axios.post('/userInfo/userAdd', params, {responseType: 'blob'}).then(res => res).catch(res => res);
};
export const userSave = params => {
    return axios.post('/staff/sysStaff/save', params).then(res => res).catch(res => res);
};

export const userReset = params => {
    return axios.post('/staff/sysStaff/reset', params).then(res => res).catch(res => res);
};

export const userUpdate = params => {
    return axios.post('/staff/sysStaff/update', params).then(res => res).catch(res => res);
};

export const batchRemoveUser = params => {
    return axios.post('/staff/sysStaff/delete', params, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(res => res).catch(res => res);
};

export const userQuery = params => {
    return axios.post('/staff/sysStaff/query', params).then(res => res).catch(res => res);
};

//用户头像上传
export const headerPic = params => {
    return axios.post('/userInfo/fileUpload', params, {responseType: 'blob'}).then(res => res).catch(res => res);
};
//////////////////////////////////////////////////////////////////////////////
//角色新建
export const roleSave = params => {
    return axios.post('/rolemanager/sysRole/save', params).then(res => res).catch(res => res);
};

export const roleUpdate = params => {
    return axios.post('/rolemanager/sysRole/update', params).then(res => res).catch(res => res);
};

export const batchRemoveRole = params => {
    return axios.post('/rolemanager/sysRole/delete', params, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(res => res).catch(res => res);
};

export const roleQuery = params => {
    return axios.post('/rolemanager/sysRole/queryWithCondition', params).then(res => res).catch(res => res);
};

export const roleQueryRoleList = params => {
    return axios.post('/rolemanager/sysRole/queryAllRole').then(res => res).catch(res => res);
};
export const roleQueryAll = params => {
    return axios.post('/rolemanager/sysRole/queryUserRole', params).then(res => res).catch(res => res);
};

export const userRoleAlloc = params => {
    return axios.post('/rolemanager/sysRole/userRoleAlloc', params, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(res => res).catch(res => res);
};
///////////////////////////////////////////////////////////////////////////////
//菜单新建
export const menuSave = params => {
    return axios.post('/menuManagers/sysMenu/save', params).then(res => res).catch(res => res);
};

export const menuUpdate = params => {
    return axios.post('/menuManagers/sysMenu/update', params).then(res => res).catch(res => res);
};

export const batchRemoveMenu = params => {
    return axios.post('/menuManagers/sysMenu/delete', params, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(res => res).catch(res => res);
};

export const menuQuery = params => {
    return axios.post('/menuManagers/sysMenu/query', params).then(res => res).catch(res => res);
};
export const menuList = params => {
    return axios.post('/menuManagers/sysMenu/menuList').then(res => res).catch(res => res);
};
export const menuListOfData = params => {
    return axios.post('/menuManagers/sysMenu/menuListOfData').then(res => res).catch(res => res);
};

export const menuQueryAll = params => {
    return axios.post('/menuManagers/sysMenu/queryRoleMenu', params).then(res => res).catch(res => res);
};
export const queryRoleAllocMenu = params => {
    return axios.post('/menuManagers/sysMenu/queryRoleAllocMenu', params).then(res => res).catch(res => res);
};
export const roleMenuAlloc = params => {
    return axios.post('/menuManagers/sysMenu/roleMenuAlloc', params).then(res => res).catch(res => res);
};
//获取当前登陆用户菜单
export const getCurrentUserMenuList = _ => {
    return axios.post('/menuManagers/sysMenu/getMenuList').then(res => res).catch(res => res);
};
///////////////////////////////////////////////////////////////////////////////
//按钮新建
export const buttonSave = params => {
    return axios.post('/buttonManager/sysButton/save', params).then(res => res).catch(res => res);
};

export const buttonUpdate = params => {
    return axios.post('/buttonManager/sysButton/update', params).then(res => res).catch(res => res);
};

export const batchRemoveButton = params => {
    return axios.post('/buttonManager/sysButton/delete', params, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(res => res).catch(res => res);
};

export const menuButtonAlloc = params => {
    return axios.post('/buttonManager/sysButton/menuButtonAlloc', params, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(res => res).catch(res => res);
};

export const buttonQuery = params => {
    return axios.post('/buttonManager/sysButton/query', params).then(res => res).catch(res => res);
};

export const buttonQueryAll = params => {
    return axios.post('/buttonManager/sysButton/queryMenuButton', params).then(res => res).catch(res => res);
};

export const buttonOfRoleQuery = params => {
    return axios.post('/buttonManager/sysButton/queryRoleMenuButton', params).then(res => res).catch(res => res);
};
export const queryRoleMenuButtonAll = params => {
    return axios.post('/buttonManager/sysButton/queryRoleMenuButtonAll', params).then(res => res).catch(res => res);
};
export const roleMenuButtonAlloc = params => {
    return axios.post('/buttonManager/sysButton/roleMenuButtonAlloc', params, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(res => res).catch(res => res);
};
///////////////////////////////////////////////////////////////////////////////
//参数组新增
export const paramGroupAdd = params => {
    return axios.post('/paraManager/sysCodeInfo/save', params).then(res => res).catch(res => res);
};

export const batchRemoveParamGroup = params => {
    return axios.post('/paraManager/sysCodeInfo/delete', params, {headers: {'Content-Type': 'application/json;charset=utf-8'}}).then(res => res).catch(res => res);
};

export const paramGroupUpdate = params => {
    return axios.post('/paraManager/sysCodeInfo/update', params).then(res => res).catch(res => res);
};

export const paramGroupQuery = params => {
    return axios.post('/paraManager/sysCodeInfo/query', params).then(res => res).catch(res => res);
};

export const paramGroupQueryByPid = params => {
    return axios.post('/paraManager/sysCodeInfo/queryByPid', params).then(res => res).catch(res => res);
};
///////////////////////////////////////////////////////////////////////////////
//问题新增
export const fileSave = params => {
    return axios.post('/content/circular/save', params).then(res => res).catch(res => res);
};
//问题新增
export const questionSave = params => {
    return axios.post('/content/question/save', params).then(res => res).catch(res => res);
};
//问题详情
export const questionDetail = params => {
    return axios.post('/content/detail', params).then(res => res).catch(res => res);
};
//问题名ID映射list
export const questionAllList = params => {
    return axios.post('/content/question/all/list', params).then(res => res).catch(res => res);
};
//问题详情
export const questionDetailWithFeed = params => {
    return axios.post('/content/question/detail', params).then(res => res).catch(res => res);
};
//问题详情
export const fileDetailWithFeed = params => {
    return axios.post("/content/question/detail", params).then(res => res).catch(res => res);
};
//问题更新
export const questionUpdate = params => {
    return axios.post('/content/question/update', params).then(res => res).catch(res => res);
};
//问题更新
export const fileUpdate = params => {
    return axios.post('/content/circular/update', params).then(res => res).catch(res => res);
};
//问题删除
export const questionDelete = params => {
    return axios.post('/content/delete', params).then(res => res).catch(res => res);
};
//问题删除
export const filePaperDelete = params => {
    return axios.post('/content/delete', params).then(res => res).catch(res => res);
};
//问题列表条件查询
export const fileListQuery = params => {
    return axios.post('/content/circular/list', params).then(res => res).catch(res => res);
};
//问题列表条件查询
export const fileUploadListQuery = params => {
    return axios.post('/content/attachment/list', params).then(res => res).catch(res => res);
};
//问题列表条件查询
export const questionQuery = params => {
    return axios.post('/content/circular/list', params).then(res => res).catch(res => res);
};
//问题反馈
export const questionFeedback = params => {
    return axios.post('/content/feedback/add', params).then(res => res).catch(res => res);
};
///////////////////////////////////////////////////////////////////////////////
//案例新增
export const caseSave = params => {
    return axios.post('/content/case/save', params).then(res => res).catch(res => res);
};
//案例详情
export const caseDetail = params => {
    return axios.post('/content/detail', params).then(res => res).catch(res => res);
};
//案例删除
export const caseDelete = params => {
    return axios.post('/content/delete', params).then(res => res).catch(res => res);
};
//案例列表条件查询
export const caseQuery = params => {
    return axios.post('/content/case/list', params).then(res => res).catch(res => res);
};
//案例更新
export const caseUpdate = params => {
    return axios.post('/content/case/update', params).then(res => res).catch(res => res);
};
///////////////////////////////////////////////////////////////////////////////
//通告新增
export const noticeSave = params => {
    return axios.post('/content/circular/save', params).then(res => res).catch(res => res);
};
//通告详情
export const noticeDetail = params => {
    return axios.post('/content/detail', params).then(res => res).catch(res => res);
};
//通告删除
export const noticeDelete = params => {
    return axios.post('/content/delete', params).then(res => res).catch(res => res);
};
//通告列表查询
export const noticeList = params => {
    return axios.post('/content/circular/list', params).then(res => res).catch(res => res);
};
//通告更新
export const noticeUpdate = params => {
    return axios.post('/content/circular/update', params).then(res => res).catch(res => res);
};
///////////////////////////////////////////////////////
//码表获取
export const getCode = params => {
    return axios.post('/paraManager/sysCodeInfo/getCode', params).then(res => res).catch(res => res);
};
//客户列表下拉
export const getCrmList = _ => {
    return axios.post('/crm/customer/all/list').then(res => res).catch(res => res);
};
///////////////////////////////////////////////////////
//理赔查询
export const getPage = params => {
    return axios.post('/policy/claim/query', params).then(res => res).catch(res => res);
};
//理赔回访查询
export const getVisitQuery = params => {
    return axios.post('/policy/claim/visitClaimQuery', params).then(res => res).catch(res => res);
};
//理赔回访满意度更新
export const claimVisitUpdate = params => {
    return axios.post('/policy/claim/updateVisitSatisLevel', params).then(res => res).catch(res => res);
};
//理赔回访设置
export const claimVisitNeedUpdate = params => {
    return axios.post('/policy/claim/updateNeedVisit', params).then(res => res).catch(res => res);
};
//理赔回访留言新增
export const addClaimFollowRecord = params => {
    return axios.post('/policy/claim/addClaimFollowRecord', params).then(res => res).catch(res => res);
};
//理赔提醒
export const getNoticePage = params => {
    return axios.post('/policy/claim/noticeList', params).then(res => res).catch(res => res);
};
//历史案件查询
export const getHis = params => {
    return axios.post('/policy/main/queryEffectivePolicy', params).then(res => res).catch(res => res);
};
//理赔新增
export const saveClaim = params => {
    return axios.post('/policy/claim/save', params).then(res => res).catch(res => res);
};
//理赔更新
export const updateClaimDetail = params => {
    return axios.post('/policy/claim/update', params).then(res => res).catch(res => res);
};
//理赔派工
export const updateClaim = params => {
    return axios.post('/policy/claim/dispatch', params).then(res => res).catch(res => res);
};
//理赔详情
export const claimDetail = params => {
    return axios.post('/policy/claim/queryDetail', params).then(res => res).catch(res => res);
};
//理赔查询历史案件查询
export const getHisPage = params => {
    return axios.post('/policy/claim/queryHistoryCaseList', params).then(res => res).catch(res => res);
};
//提醒等级查验
export const remainderValid = params => {
    return axios.post('/claim/checkNotice', params).then(res => res).catch(res => res);
};
//理赔提醒等级修改
// export const remainderChange = params => {
//     return axios.post('/policy/claim/updateNoticeLevel', params).then(res => res).catch(res=>res);
// };
export const remainderChange = params => {
    return axios.post('/claim/addNotice', params).then(res => res).catch(res => res);
};
//取消提醒
export const remainderCancel = params => {
    return axios.post('/claim/cancelNotice', params).then(res => res).catch(res => res);
};
//理赔结案
export const closeCase = params => {
    return axios.post('/policy/claim/closeCase', params).then(res => res).catch(res => res);
};
//理赔撤案
export const withdraw = params => {
    return axios.post('/policy/claim/withdraw', params).then(res => res).catch(res => res);
};
//理赔新增文件查询
export const claimAddFileQuery = params => {
    return axios.post('/attachment/list', params).then(res => res).catch(res => res);
};
//理赔删除
export const claimDelete = params => {
    return axios.post('/policy/claim/delete', params).then(res => res).catch(res => res);
};
//理赔详情跳转方法
export const jumpToCaseDetail = params => {
    let flag = params.$this.$router.options.routes[5].children.some(item => {
        return item.path === params.pathName;//'/claimDetail'+params.$this.form.claimNo
    })
    //{path:'/claimDetail/:policyNo', component:resolve => require(['./components/claimManager/claimDetail.vue'], resolve), props: true, name:'案件详情'},
    if (!flag) {
        params.$this.$router.options.routes[5].children.push({//插入路由
            name: params.tageName, //params.$this.form.claimNo+'_历史案件列表',
            path: params.pathName, //'/claimHis'+params.$this.form.claimNo,
            component: resolve => require(['@/components/claimManager/claimDetail.vue'], resolve), //'@/components/claimManager/claimHis.vue'
        });
        params.$this.$router.addRoutes(params.$this.$router.options.routes);
        let claimRouteNum = JSON.parse(sessionStorage.getItem("claimRouteNum"));
        if (!claimRouteNum) {
            claimRouteNum = [];
        }
        claimRouteNum.push({
            //插入路
            name: params.tageName, //params.$this.form.claimNo+'_历史案件列表',
            path: params.pathName, //'/claimHis'+params.$this.form.claimNo,
        });
        sessionStorage.setItem("claimRouteNum", JSON.stringify(claimRouteNum));
    }

    params.$this.$router.push({path: params.pathName, query: params.param});//'/claimHis'+params.$this.form.claimNo
};


//客户文件列表查询
export const customerFileQuery = params => {
    return axios.post('/attachment/getCustomerAttachments', params).then(res => res).catch(res => res);
};
//文件列表查询
export const fileQuery = params => {
    return axios.post('/attachment/queryList', params).then(res => res).catch(res => res);
};
//文件删除
export const fileDelete = params => {
    return axios.get('/file/delete' + params,).then(res => res).catch(res => res);
};
//文件全量下载POST方式
export const fileDownloadPost = params => {
    return axios.post('/file/generateZip', params).then(res => {
        if (res.data.success) {
            let zipId = res.data.data["id"];
            const ctx = process.env.API_ROOT;
            const access_token = VueCookies.get('access_token');
            let circleUrl = "";

            if (access_token && access_token.length > 0) {
                circleUrl = ctx + "/file/downloadZip?id=" + zipId + "&Authorization=" + access_token;

                let a = document.createElement("a");
                a.style.display = "none";
                a.setAttribute("href", circleUrl);
                document.body.appendChild(a);
                a.click();
            }
        }
    }).catch(res => res);
};


//保险标的接口

export const insurancesubjectAdd = params => {
    return axios.post('/insurancesubject/add', params).then(res => res.data).catch(res => res.data);
};
export const insurancesubjectDelete = params => {
    return axios.post('/insurancesubject/delete', params).then(res => res.data).catch(res => res.data);
};
export const insurancesubjectUpdate = params => {
    return axios.post('/insurancesubject/update', params).then(res => res.data).catch(res => res.data);
};

//首页数据展示接口
//获取财务首页
export const financialQuery = params => {
    return axios.get('/inquiry/cw/first').then(res => res.data);
};
//正常保费催收
export const payPolicyListHomepage = params => {
    return axios.post('/pay/policy/cw/first/pay/list', params).then(res => res.data);
};
//开票管理列表接口
export const invoiceListHomepage = params => {
    return axios.post('/invoice/cw/first/invoice/list', params).then(res => res.data);
};
//获取承保首页
export const underWritingQuery = params => {
    return axios.get('/inquiry/hby/first').then(res => res.data);
};
//获取出单首页
export const policyQuery = params => {
    return axios.post('/inquiry/cdy/first', params).then(res => res.data);
};
//获取理赔员首页
export const claimHomeQuery = params => {
    return axios.post('/claim/homepage/user/overview', params).then(res => res.data);
};
//获取理赔管理员进行中首页
export const CHMProcessingQuery = params => {
    return axios.post('/claim/homepage/manager/overview', params).then(res => res.data);
};
//获取理赔管理员统计首页
export const CHMCountViewQuery = params => {
    return axios.get('/claim/homepage/manager/statistics').then(res => res.data);
};

//保单转入续保询价
export const turnToEnquiryPost = params => {
    return axios.post('/policy/renew/addManualRenew', params).then(res => res.data);
};
//理赔员列表
export const claimUserList = params => {
    return axios.post('/claim/homepage/user/overview/list', params).then(res => res.data);
};
//理赔经理列表1
export const claimManagerList = params => {
    return axios.post('/claim/homepage/manager/overview/list', params).then(res => res.data);
};
//理赔经理列表2
export const claimManagerStatisticsList = params => {
    return axios.post('/claim/homepage/manager/statistics/list', params).then(res => res.data);
};
//首页待出单
export const queryWillPolicyList = params => {
    return axios.post('/inquiry/cdy/first/inquiry/list', params).then(res => res.data);
};
//出单首页列表
export const queryPolicyList = params => {
    return axios.post('/inquiry/cdy/first/list', params).then(res => res.data);
};
//核保首页列表
export const queryAuditPolicyList = params => {
    return axios.post('/inquiry/hby/first/policy/list', params).then(res => res.data);
};
//询价首页列表
export const queryAuditAskPolicyList = params => {
    return axios.post('/inquiry/hby/first/inquiry/list', params).then(res => res.data);
};
//续保丢失
export const manualLost = params => {
    return axios.post('/policy/renew/addManualLost', params).then(res => res.data);
};
//询价批量丢失
export const inquiryManualLost = params => {
    return axios.post('/inquiry/batch/loss', params).then(res => res.data);
};
//询价批量投保状态
export const inquiryManualNewPolicy = params => {
    return axios.post('/inquiry/update/batch/state', params).then(res => res.data);
};
//投保人下拉
export const customerAllList = params => {
    return axios.post('/crm/customer/all/list', params).then(res => res.data);
};
//出单保单录入信息查询
export const policyDetailInfo = params => {
    return axios.post('/inquiry/policy/detail', params).then(res => res.data);
};
//通告附件上传
export const filePaperUpload = params => {
    return axios.post('/content/attachment/save', params).then(res => res.data);
};
//
export const groupOfRoleList = params => {
    return axios.post('/inquiry/hby/first/detail', params).then(res => res.data);
};
//注销保单
export const lossWarrant = params => {
    return axios.post('/policy/main/loss', params).then(res => res.data);
};
//已合作客户标的名称修改
export const changeSubjectName = params => {
    return axios.post('/manage/customer/update/insuranceSubject', params).then(res => res.data);
};
//保险公司业绩查询
export const companyAchCount = params => {
    return axios.post('/census/company/year/count', params).then(res => res.data);
};
//公司业绩目标保存
export const companyAchTargetSave = params => {
    return axios.post('/census/save', params).then(res => res.data);
};
//公司业绩目标查询
export const companyAchTargetQuery = params => {
    return axios.post('/census/company/rate', params).then(res => res.data);
};
//签单业绩查询
export const signAchQuery = params => {
    return axios.post('/census/sign/rate', params).then(res => res.data);
};
//业务员业绩目标查询
export const sellerAchTargetQuery = params => {
    return axios.post('/census/seller/year/rate', params).then(res => res.data);
};
//业绩列表查询
export const censusSignList = params => {
    return axios.post('/census/sign/list', params).then(res => res.data);
};
//续保清单删除
export const renewPolicyDelete = params => {
    return axios.post('/policy/renew/delete', params).then(res => res.data);
};
//询价列表删除
export const inquiryDiscard = params => {
    return axios.post('/inquiry/discard', params).then(res => res.data);
};
//理赔案件新增列表查询
export const queryClaimList = params => {
    return axios.post('/policy/main/queryClaimList', params).then(res => res.data);
};
//理赔新增案件-查询标的是否存在询价
export const checkInsuranceSubjectState = params => {
    return axios.post('/inquiry/check/insuranceSubject', params).then(res => res.data);
};
//客户信息-查询船舶信息
export const insurancesubjectDetail = params => {
    return axios.post('/insurancesubject/detail', params).then(res => res.data);
};
//客户信息-保存船舶信息
export const insurancesubjectContentSave = params => {
    return axios.post('/insurancesubject/update/content', params).then(res => res.data);
};
//客户信息-关联挂靠公司
export const affiliatedCompanyAdd = params => {
    return axios.post('/insurancesubject/customer/add', params).then(res => res.data);
};
//客户信息-关联挂靠公司删除
export const affiliatedCompanyDelete = params => {
    return axios.post('/insurancesubject/customer/delete', params).then(res => res.data);
};
//客户信息-赔付情况查询
export const compensationSituationQuery = params => {
    return axios.post('/crm/customer/claim/list', params).then(res => res.data);
};
//客户信息-赔付情况简单赔付率合计查询
export const compensationSituationCountQuery = params => {
    return axios.post('/crm/customer/claim/rate', params).then(res => res.data);
};
//客户信息-已询价险种查询
export const queryInquiredList = params => {
    return axios.post('/insurancesubject/all/insuranceType', params).then(res => res.data);
};
//客户信息-标的新增跟进
export const addSubjectFollowUpOperate = params => {
    return axios.post('/insurancesubject/follow/add', params).then(res => res.data);
};
//客户信息-标的跟进列表查询
export const querySubjectFollowUpList = params => {
    return axios.post('/insurancesubject/follow/list', params).then(res => res.data);
};
//用户操作-修改用户密码
export const updateStaffPassword = params => {
    return axios.post('/staff/sysStaff/updatePass', params).then(res => res.data);
};
//客户管理-客户特点修改
export const customerUpdatePoint = params => {
    return axios.post('/manage/customer/update/point', params).then(res => res.data);
};
//客户管理-客户名称修改
export const customerNameChange = params => {
    return axios.post('/manage/customer/update/name', params).then(res => res.data);
};
//客户管理-客户业务员修改
export const customerSellerChange = params => {
    return axios.post('/manage/customer/update/seller', params).then(res => res.data);
};
//客户管理-船名修改
export const shipNameChange = params => {
    return axios.post('/manage/customer/update/subject/name', params).then(res => res.data);
};
//首页-佣金开票金额统计
export const commissionStatistics = params => {
    return axios.post('/invoice/commission/statistics', params).then(res => res.data);
};
//首页-佣金开票金额-列表
export const commissionStatisticsList = params => {
    return axios.post('/invoice/commission/statistics/detailList', params).then(res => res.data);
};
//财务管理-批量修改佣金比例
export const batchModificationOfCommissionRate = params => {
    return axios.post('/foreign/pay/policy/batch/updateYongjinRate', params).then(res => res.data);
};
//财务管理-批量修改佣金比例-旧值查询
export const queryPremiumBrokerageRatio = params => {
    return axios.post('/foreign/pay/policy/premiumBrokerageRatio', params).then(res => res.data);
};
//crm-保险标的-标的归属客户变更
export const changeOfTheSubjectVestedCustomer = params => {
    return axios.post('/manage/update/subject/customer', params).then(res => res.data);
};
//理赔管理-理赔查询-已决赔付和预估赔付的总计金额
export const claimQuerySum = params => {
    return axios.post('/policy/claim/query/sum', params).then(res => res.data);
};

//财务管理-备注添加
export const contactRemarkBatchUpdate = params => {
    return axios.post('/contact/remark/batchUpdate', params).then(res => res.data);
};
//财务管理-备注查询
export const contactRemarkQuery = params => {
    return axios.post('/contact/remark/contact', params).then(res => res.data);
};
//询价详情-转入等待
export const updateInquiryToWait = params => {
    return axios.post('/inquiry/update/wait', params).then(res => res.data);
};

//理赔管理-未决案件-催办案件
export const getUrgentList = params => {
    return axios.post('/policy/claim/urge/query', params).then(res => res.data);
};
//理赔管理-催办状态更新
export const updateUrgentState = params => {
    return axios.post('/policy/claim/add/urge', params).then(res => res.data);
};
//理赔管理-催办留言
export const updateUrgentFollow = params => {
    return axios.post('/policy/claim/add/follow', params).then(res => res.data);
};
//用户管理-禁用
export const userBan = params => {
    return axios.post('/staff/sysStaff/ban', params).then(res => res.data);
};
//用户管理-启用
export const userUnban = params => {
    return axios.post('/staff/sysStaff/unban', params).then(res => res.data);
};
//共保管理-新增共保
export const addCommCompany = params => {
    return axios.post('/commCompany/add', params).then(res => res.data);
};
//共保管理-共保列表查询
export const queryCommCompanyList = params => {
    return axios.post('/commCompany/list', params).then(res => res.data);
};
//共保管理-共保修改
export const updateCommCompany = params => {
    return axios.post('/commCompany/update', params).then(res => res.data);
};
//共保管理-共保删除
export const deleteCommCompany = params => {
    return axios.post('/commCompany/delete', params).then(res => res.data);
};
//共保管理-共保首选设置
export const setFirstCommCompany = params => {
    return axios.post('/commCompany/setfirst', params).then(res => res.data);
};






// WEBPACK FOOTER //
// ./src/api/api.js